import MuiDialogActions from '@mui/material/DialogActions';
import { SxProps, Theme } from '@mui/material/styles';

type DialogActionsProps = {
  sx?: SxProps<Theme>;
};

export default function DialogActions({
  children,
  sx,
}: React.PropsWithChildren<DialogActionsProps>) {
  return (
    <MuiDialogActions
      sx={[
        (theme) => ({
          alignItems: 'center',
          borderTop: `solid 1px ${theme.brandV2.colors.treadGray7}`,
          display: 'flex',
          justifyContent: 'flex-end',
          px: 2,
          py: 1.5,
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {children}
    </MuiDialogActions>
  );
}
